import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.RECORDS_LIST, { params: payload })
}
